import { modalController } from '@ionic/vue'
import ImageViewer from '@/components/app/ImageViewer.vue'

export const useGallery = createGlobalState(
    () => {
        const openGallery = async (gallery) => {
            const modal = await modalController.create({
                cssClass: 'ds-modal-fullscreen',
                component: ImageViewer,
                componentProps: {
                    gallery,
                },
            })

            await modal.present()
        }

        return {
            openGallery,
        }
    },
)
